<template>
    <div class="main">
        <div class="body-content">
            <div class="page-header">
                <h1>Cartin List</h1>
            </div>
            <div class="form-group">
                <div class="form-item2">
                    <label for="party">Party</label>
                    <select id="party" v-model="partyid">
                        <option value="0">Select Party</option>
                        <option v-for="party in party" :key="party.autoid" :value="party.autoid">
                            {{ party.short_name }}
                        </option>
                    </select>
                </div>
                <div class="form-item2">
                    <label for="vesselName">Vessel *</label>
                    <v-select :clearable="false" id="vesselName" placeholder="Select Vessel" v-model="vesselID"
                        ref="vesselName" :options="vessel" label="Name" :reduce="vessel => vessel.Vesselid"
                        selectOnTab="True" />
                </div>
                <div class="form-item2" style="width: 15%;">
                    <label for="voyageName">Voyage *</label>
                    <v-select :clearable="false" id="voyageName" v-model="voyageID" :options="voyage" label="Name"
                        :reduce="voyage => voyage.Voyageid" selectOnTab="True" />
                </div>
                <div class="form-item2" style="width: 20%;">
                    <label for="area">Area *</label>
                    <v-select :clearable="false" id="area" v-model="areaID" :options="Area" label="Name"
                        :reduce="area => area.locationid" selectOnTab="True" />
                </div>
                <div class="form-item2">
                    <label for="vcnname">VCN No *</label>
                    <v-select :clearable="false" id="vcnname" v-model="vcnID" :options="vcns" label="vcnName"
                        :reduce="vcn => vcn.vcnID" selectOnTab="True" />
                </div>
                <div class="form-item2" style="width: 15%; margin-top: 12px;">
                    <button type="button" class="excel-button" @click="getCartinList"
                        :disabled="isSubmitting">Show</button>
                </div>
            </div>
            <hr />
            <div class="table-container">
                <v-data-table class="compact-data-table" density="compact" fixed-header fixed-footer height="420"
                    :headers="headers" :items="cartinList" item-key="autoid" sort-icon="mdi-swap-vertical"
                    sort-asc-icon="mdi-arrow-up" sort-desc-icon="mdi-arrow-down">
                </v-data-table>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios';
import VSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import { useToast } from 'vue-toastification';
import { VDataTable } from 'vuetify/components';
import * as cs from '../assets/js/commonscript.js'
export default {
    components: {
        VSelect,
        VDataTable,
    },
    data() {
        return {
            isSubmitting: false,
            vessel: JSON.parse(localStorage.getItem('vessel')) || [],
            voyage: JSON.parse(localStorage.getItem('voyage')) || [],
            vcns: JSON.parse(localStorage.getItem('vcns')) || [],
            party: JSON.parse(localStorage.getItem('party')) || [],
            partyid: 0,
            Area: [],
            vesselID: 0,
            voyageID: 0,
            vcnID: 0,
            areaID: 0,
            applicantid: 0,
            accountid: 0,
            cartinList: [],
            bookingSearch: '',
            containerSearch: '',
            headers: [
                { title: 'SNo', key: 'sno', sortable: true },
                { title: 'Booking No', key: 'bookingno', sortable: true },
                { title: 'Container No', key: 'contnumber', sortable: true },
                { title: 'ISO', key: 'isosize', sortable: true },
                { title: 'Gross Wt', key: 'grosswt', sortable: true },
                { title: 'Exporter', key: 'exporter', sortable: true }
            ],
        };
    },
    watch: {
        'vcnID'(value) {
            this.FillVCNDetails(value)
        },
        'vesselID'() {
            this.updateVCNFromVesselAndVoyage();
        },
        'voyageID'() {
            this.updateVCNFromVesselAndVoyage();
        },
        'areaID'() {
            this.updateVCNFromVesselAndVoyage();
        }

    },
    mounted() {
        this.fetchVcnList();
        this.fetchMasterLocations();
    },
    methods: {
        updateApplicantAccountIds(value) {
            const AppAcc = cs.GetAppAccFromParty(value)
            this.applicantid = AppAcc.applicantid
            this.accountid = AppAcc.accountid
        },
        async fetchMasterLocations() {
            this.isLoading = true;
            this.error = null;
            const token = localStorage.getItem('access_token');
            if (!token) {
                this.error = 'No token found in localStorage';
                this.isLoading = false;
                return;
            }
            try {
                const config = {
                    headers: {
                        'accept': 'application/json',
                        'Authorization': `Bearer ${token}`,
                    },
                };
                const response = await axios.get('/master_location_list/', config);
                this.Area = response.data[2];
            } catch (error) {
                this.error = 'Error fetching Master Locations. Check console for details.';
            } finally {
                this.isLoading = false;
            }
        },
        async fetchVcnList() {
            const token = localStorage.getItem('access_token');
            try {
                if (!token) {
                    useToast().error('Authentication token not found.');
                    return;
                }
                const config = {
                    headers: {
                        'accept': 'application/json',
                        'Authorization': `Bearer ${token}`,
                    },
                };
                const response = await axios.get('/vcn_list/', config);
                var data = response.data[2]
                data.push({ "vcnID": 0, "vcnName": "Select VCN", "vesselID": 0, "import_voyage": 0, "export_voyage": 0, "MlocID": 0, "ImpRotNo": "", "ImpRotDate": null, "ExpRotNo": "", "ExpRotDate": null, "BerthDate": null, "EgmDate": null, "SailDate": null, "IsSail": 0, "vesselLocation": 0, "created_by": 0, "CreateDate": null, "last_modified_by": 0, "ModiDate": null, "VesselName": "", "import_voyageName": "", "export_voyageName": "", "area": "", "Vesselarea": "" })
                this.vcns = data;
            } catch (error) {
                console.error('Error fetching VCN list:', error);
                useToast().error(error.response?.data?.message || 'Error fetching VCN list.');
            }
        },
        FillVCNDetails(value) {
            const selvcn = this.vcns.find(vcn => vcn.vcnID === value);
            console.log('Selected VCN details:', selvcn);
            if (selvcn && selvcn.vcnID !== 0) {
                this.vesselID = selvcn.vesselID;
                this.voyageID = selvcn.export_voyage;
                this.areaID = selvcn.MlocID;
            }
        },
        updateVCNFromVesselAndVoyage() {
            this.vcnID = 0;
            if (this.vesselID && this.voyageID) {
                const matchingVcn = this.vcns.find(vcn => vcn.vesselID === this.vesselID && vcn.export_voyage === this.voyageID && vcn.MlocID === this.areaID);
                if (matchingVcn) {
                    this.vcnID = matchingVcn.vcnID;
                }
            }
        },
        async getCartinList() {
            if (this.partyid==0 || this.vesselID==0 || this.voyageID==0 || this.vcnID==0 || this.areaID==0) {
                useToast().error('Please fill in all required fields.');
                return;
            }
            try {
                if (this.partyid != 0) {
                    this.updateApplicantAccountIds(this.partyid)
                }
                this.isSubmitting = true;
                console.log(this.vcnID)
                const response = await axios.get(`get_allcartin_by_vcn/${this.vcnID}/${this.applicantid}/`, {
                    headers: {
                        'accept': 'application/json',
                        'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
                    },
                });
                const apiItems = response.data[2] || [];

                this.cartinList = apiItems.map((item, index) => ({
                    ...item,
                    sno: index + 1,
                }));
                console.log('Fetched cartin list:', this.cartinList);
            } catch (error) {
                console.error('Error fetching cartin list:', error);
                useToast().error('Failed to fetch cartin list. Please try again.');
            } finally {
                this.isSubmitting = false;
            }
        },
    },
};

</script>
<style scoped>
.table-container {
    /*max-height: 100%;*/
    overflow: auto;
    border: 1px solid #ddd;
    border-radius: 10px;
}

.transaction-table {
    width: 100%;
    height: 100%;
    border-collapse: collapse;
}

.transaction-table th,
.transaction-table td {
    padding: 8px;
    text-align: left;
    border-bottom: 1px solid #ddd;
}

.transaction-table th {
    background-color: #f2f2f2;
    font-weight: bold;
}

.transaction-table th .filter-icon {
    cursor: pointer;
    margin-left: 5px;
}

.compact-data-table ::v-deep .v-data-table-header__content {
    background-color: #0e5a87 !important;
    color: #ffffff !important;
    font-weight: 700 !important;
}

.compact-data-table ::v-deep .v-data-table__th,
.compact-data-table ::v-deep .v-data-table__td {
    padding: 4px 10px !important;
    font-size: 0.9rem !important;
}

.compact-data-table ::v-deep .v-data-table__th {
    min-height: 34px !important;
    height: 34px !important;
    line-height: 1.2 !important;
    background-color: #0e5a87 !important;
}

.compact-data-table ::v-deep .v-data-table-header__content {
    min-height: 34px !important;
    height: 34px !important;
    line-height: 1.2 !important;
}

.compact-data-table ::v-deep .v-data-table__td {
    min-height: 34px !important;
}

.compact-data-table ::v-deep .v-data-table-header__sort-icon {
    color: rgba(255, 255, 255, 0.95) !important;
    margin-left: 6px !important;
}

.compact-data-table ::v-deep .v-data-table__th>.v-data-table-header__content {
    color: #ffffff !important;
}

.header-search-box {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 8px 0 8px 12px;
}

.header-search {
    width: 320px;
    max-width: 100%;
}


/* Form group styling for form elements */
.field-p-100 {
    width: 100%;
}

.form-group {
    display: flex;
    flex-wrap: wrap;
    gap: 5px;
    margin-bottom: 5px;
}

.form-item {
    width: 32%;
}

.form-item2 {
    width: 24%;
}

.form-item3 {
    width: calc(50% - 10px);
    margin-right: 10px;
}

.form-item3:nth-child(2n) {
    margin-right: 0;
}

/* remove right-side spacing and adapt modal to smaller screens */
.modal-content.small {
    width: 95%;
    max-width: 960px;
    padding: 0;
    margin-right: 0;
    box-sizing: border-box;
}

.modal-subtitle {
    margin: 4px 0 0;
    font-size: 0.95rem;
    color: #333;
}

.modal-subtitle-value {
    font-weight: 700;
    font-size: 1.1rem;
    color: #0e5a87;
    margin: 0 4px;
}

select,
input[type="text"],
input[type="date"],
input[type="number"],
v-select {
    padding: 5px;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 14px;
    background-color: #FFF;
    width: 100%;
}

.excel-button {
    background-color: #17a2b8;
    color: white;
    border: none;
    padding: 10px 15px;
    border-radius: 5px;
    cursor: pointer;
    margin-right: 10px;
}

.excel-button.compact {
    padding: 6px 10px;
    font-size: 0.9rem;
    min-height: 32px;
}

.page-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    margin-bottom: 10px;
    flex-wrap: wrap;
}

.page-header h1 {
    margin: 0;
    font-size: 1.6rem;
}

.header-actions {
    display: flex;
    align-items: center;
    gap: 8px;
}

.add-movement-wrapper {
    display: flex;
    justify-content: center;
    margin-top: 12px;
}

.excel-button:disabled {
    background-color: #6c757d;
    cursor: not-allowed;
    opacity: 0.6;
}

/* Modal styles reused from other components */
.modal-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.45);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 99999;
    pointer-events: auto;
}

.modal-content.small {
    width: min(92vw, 940px);
    max-width: 960px;
    background: #fff;
    border-radius: 8px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    max-height: 90vh;
    margin: 1rem;
    box-sizing: border-box;
}

.modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 16px;
    border-bottom: 1px solid #eee;
}

.modal-body {
    padding: 12px 16px;
    overflow-y: auto;
    flex: 1 1 auto;
}

.modal-footer {
    padding: 12px 16px;
    border-top: 1px solid #eee;
    text-align: right;
}

.cancel-button,
.save-button {
    border: 1px solid transparent;
    border-radius: 4px;
    padding: 8px 16px;
    font-weight: 600;
    cursor: pointer;
    transition: transform 0.12s ease, background-color 0.12s ease, filter 0.12s ease;
}

.cancel-button {
    background-color: #fff;
    color: #dc3545;
    border-color: #dc3545;
}

.cancel-button:hover {
    background-color: #f8d7da;
    color: #a71d2a;
    transform: translateY(-1px);
}

.save-button {
    margin-left: 10px;
    background-color: #28a745;
    color: #fff;
    border-color: #28a745;
}

.save-button:hover {
    background-color: #218838;
    filter: brightness(1.05);
}

.close-btn {
    padding: 8px 12px;
    border-radius: 4px;
    border: none;
    background: #6c757d;
    color: #fff;
    cursor: pointer;
}

.filter-row {
    display: flex;
    gap: 10px;
    align-items: center;
    flex-wrap: wrap;
}

.filter-section {
    display: flex;
    align-items: center;
    gap: 5px;
}

.filter-section label {
    white-space: nowrap;
    font-weight: bold;
}

.search-button {
    background-color: #28a745;
    color: white;
    border: none;
    padding: 8px 12px;
    border-radius: 4px;
    cursor: pointer;
    font-size: 0.9rem;
}

.search-row {
    margin-bottom: 12px;
    display: flex;
    gap: 8px;
    align-items: center;
}

.header-search-row {
    flex: 1 1 auto;
    width: auto;
    min-width: 0;
    display: flex;
    gap: 8px;
    align-items: center;
}

.search-select {
    flex: 0 0 auto;
    width: 120px;
}

.search-input {
    /*flex: 1 1 auto;*/
    width: 250px;
    padding: 6px 10px;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 0.95rem;
}
</style>